import * as React from "react";
import { Config } from "../service";
import { Container } from "./Container.jsx";
import * as cls from "./Footer.module.scss";
export { Footer, FooterView };
/**
 * Нижняя часть страницы с информацией об авторских правах.
 * @param {Object} props - Атрибуты элемента.
 * @param {integer} [props.vuz_id=0] - Идентификатор ВУЗа.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Footer({ vuz_id = 0 }) {
  const service = Config.createService("student_service");
  const request =
  {
    method: "get",
    path: `/brand/${vuz_id}/footer`,
  };
  const [response, setResponse] = React.useState(null);
  React.useEffect(() => {
    if (cache[vuz_id]) setResponse(cache[vuz_id]);
    else service.send(request, setResponse);
  }, [vuz_id]);
  const text = response ?
    (response.errors ? response.errors.join(". ") : response.footer) :
    "";
  if (response && !response.errors) cache[vuz_id] = text;
  return <FooterView text={text} />;
}
/**
 * Нижняя часть страницы с информацией об авторских правах.
 * @param {Object} props - Атрибуты элемента.
 * @param {string} props.text - Текст в формате HTML.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function FooterView({ text }) {
  return (
    <Container tagName="footer" className={cls.footer}>
      <span dangerouslySetInnerHTML={{ __html: text }} />
    </Container>
  );
}
/**
 * Кэш.
 * @private
 */
const cache = {};
